import { render } from "./PartyPicker.vue?vue&type=template&id=283857d4"
import script from "./PartyPicker.vue?vue&type=script&lang=ts"
export * from "./PartyPicker.vue?vue&type=script&lang=ts"
script.render = render

export default script